// extracted by mini-css-extract-plugin
export default {"showimage":"ShowImge_showimage__053HB","centerdiv":"ShowImge_centerdiv__dtCXx","close":"ShowImge_close__zLr0I","animate-rotate":"ShowImge_animate-rotate__zIH-u"};